import type { Tokens } from '../augmentation'
import { type ComponentCreation } from './types'
import { spacing } from '../spacing'

export const createMuiFormHelperText = ({ palette }: Pick<Tokens, 'palette'>) =>
  ({
    MuiFormHelperText: {
      defaultProps: {},
      styleOverrides: {
        root: {
          marginLeft: spacing(0),
          '&.Mui-disabled': {
            color: palette.action.disabled,
          },
        },
      },
    },
  }) satisfies ComponentCreation
